var passwordI18n = {
  requirementsErrorTitle: 'Requirements do not match',
  showButtonAriaLabel: 'Show password',
  hideButtonAriaLabel: 'Hide password',
  errorAriaLabel: 'Error',
  completeAriaLabel: 'Complete',
  incompleteAriaLabel: 'Incomplete'
};
export default passwordI18n;